// debounce関数だけをlodashからインポート
import debounce from "lodash/debounce";

// 高さを設定する関数
function setViewportHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

// debounceを使用してイベントリスナーに登録
var debouncedSetHeight = debounce(setViewportHeight, 100);

window.addEventListener("resize", debouncedSetHeight);
window.addEventListener("orientationchange", debouncedSetHeight);

// 初期ロード時にも高さを設定
setViewportHeight();

// how to use.
// .--viewport-height {
//   height: calc(var(--vh, 1vh) * 100);
// }

export default setViewportHeight;
